export const ConfigTypes = {
  CREATE_VISIT: 'CreateVisit',
  GUEST: 'Guest'
};

export const ConfigOption = {
  GUEST_NUMBER: 'GuestNumber',
  HELP_DESIRED: 'HelpDesired',
  ID_PRESENTED: 'IDPresented',
  SIGNATURE: 'Signature',
  CUSTOM_FIELDS: 'CustomFields'
};
